import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const projectsPageProductDetailsSectionK = {
  productNumber: "projects_page_product_details_section.productNumber",
  height: "projects_page_product_details_section.height",
  productCategory: "projects_page_product_details_section.productCategory",
  otherDocuments: "projects_page_product_details_section.otherDocuments",
  productDescription: "projects_page_product_details_section.productDescription",
  information: "projects_page_product_details_section.information",
  goods: "projects_page_product_details_section.goods",
  documents: "projects_page_product_details_section.documents",
  links: "projects_page_product_details_section.links",
  sound: "projects_page_product_details_section.sound",
  addItem: "projects_page_product_details_section.addItem",
  width: "projects_page_product_details_section.width",
};

export const useProjectsPageProductDetailsSectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      productNumber: t(projectsPageProductDetailsSectionK.productNumber),
      height: t(projectsPageProductDetailsSectionK.height),
      productCategory: t(projectsPageProductDetailsSectionK.productCategory),
      otherDocuments: t(projectsPageProductDetailsSectionK.otherDocuments),
      productDescription: t(projectsPageProductDetailsSectionK.productDescription),
      information: t(projectsPageProductDetailsSectionK.information),
      goods: t(projectsPageProductDetailsSectionK.goods),
      documents: t(projectsPageProductDetailsSectionK.documents),
      links: t(projectsPageProductDetailsSectionK.links),
      sound: t(projectsPageProductDetailsSectionK.sound),
      addItem: t(projectsPageProductDetailsSectionK.addItem),
      width: t(projectsPageProductDetailsSectionK.width),
    }),
    [i18n.language]
  );
};